import { AbstractControl, AsyncValidatorFn } from '@angular/forms';
import { forkJoin, of } from 'rxjs';
import { first, map } from 'rxjs/operators';

import { GeolocationService, getStateCode, isTruthy, Location } from '@app/shared';

export function isLocation(
  geolocationService: GeolocationService,
): AsyncValidatorFn {
  return (control: AbstractControl) => {
    const locationNames: string[] = getLocationName(control.value);

    return (locationNames.length > 0) ? forkJoin(locationNames.map((name) =>
      geolocationService.autocomplete(name.split(',')[0]))).pipe(
        first(),
        map((locations) => locations.flat()),
        map((locations: Location[]) => {
          const invalidLocations = getInvalidLocations(control.value, locations);
          return invalidLocations.length === 0
            ? null
            : { isLocation: { value: getLocationName(invalidLocations) } };
        }),
    ) : of(null);
  };
}

function mapToLocationName(location: Partial<Location>): string {
  return !!location
    ? [
      location.name,
      ((location.countryCode === 'US' || location.countryCode === 'United States') ? getStateCode(location.stateCode) : ''),
      location.countryName,
    ]
      .filter(isTruthy)
      .join(', ')
    : '';
}

function getLocationName(locations: Location[] | string): string[] {
  if (!!locations && typeof locations === 'object' && locations.length > 0) {
    return locations.map((location) => location.name);
  }
  return [];
}

function getInvalidLocations(
  value: Location[],
  existingLocations: Location[],
): Location[] {
  const existingLocationNames = existingLocations.map((location: Location) =>
    mapToLocationName(location),
  );
  return value.filter((location) => !existingLocationNames.includes(mapToLocationName(location)));
}
